<div class="snake">
  <app-bit *ngFor="let bit of snake.bits; let i = index"
           [matTooltip]="bit.tooltip"
           [index]="i" [bit]="bit" [size]="bitSize"
           [scheme]="snake.colorScheme"></app-bit>
</div>
